/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import Config from "data/config";
import dayjs from "dayjs";
import { useMemo } from "react";
import DatePicker from "react-datepicker";

const dateTimeFormat = {
    "field.date": Config.dateFnDates.edit.date,
    "field.time": Config.dateFnDates.edit.time,
    "field.datetime": Config.dateFnDates.edit.datetime,
};
const parseFormats = {
    "field.date": Config.dates.internalFormats.date,
    "field.time": Config.dates.internalFormats.time,
    "field.datetime": Config.dates.internalFormats.datetime,
};

const DateTimeEdit = (props) => {
    const name = props?.name;
    const type = props?.type;
    const value = props?.value;
    const onChangeDateTime = props?.onChangeDateTime;

    const dateFormat = type ? dateTimeFormat[type] : dateTimeFormat["field.datetime"];
    const parseFormat = type ? parseFormats[type] : parseFormats["field.datetime"];
    const showTime = type === "field.datetime" || type === "field.time";
    const isTime = type === "field.time";

    const dateValue = useMemo(() => {
        if (value instanceof Date) {
            return value;
        }

        const date = dayjs(value, parseFormat);
        
        if (date.isValid()) {
            return date.toDate();
        }

        return null;
    }, [parseFormat, value]);

    return (
        <DatePicker
            className='simplicity-date-input'
            showTimeSelect={showTime}
            showTimeSelectOnly={isTime}
            id={`${name}_dateTime`}
            name={`${name}_dateTime`}
            selected={dateValue}
            dateFormat={dateFormat}
            onChange={onChangeDateTime}
            isClearable
            fullWidth={true}
        />
    );
};
export { DateTimeEdit };
